const portfolioData = {
  profile: {
    name: "Oghenerunor Ewhro",
    shortName: "Runor Ewhro",
    headline: "Computer Science Student | Full-Stack Developer (React/Next.js, Node/Fastify)",
    summary:
      "i like building software that feels solid to use and easy to maintain. Lately I’ve been spending most of my time on a live web app and a larger full-stack platform, getting better by working through the full process: designing it, building it, deploying it, and iterating as I go.",
    schoolStatus:
      "3rd-year Computer Science student (UNB Saint John). Open to internships, co-op terms, part-time roles, contract work, and entry-level opportunities.",
    location: "Saint John, NB (open to Remote/Hybrid/On-site in Canada)",
    graduation: "Expected 2027",
    degree: "Bachelor of Computer Science (University of New Brunswick – Saint John)",
    resumeUrl: "/resume.pdf",
    email: "rewhro@icloud.com",
    phone: "+1 (506) 271-5749",
    links: [
      { label: "GitHub", url: "https://github.com/ssjrunor" },
      { label: "LinkedIn", url: "https://www.linkedin.com/in/oghenerunor-ewhro-49b97b380/" }
    ]
  },

  quickFacts: [
    { label: "Currently", value: "3rd-year CS @ UNB Saint John (Expected 2027)" },
    { label: "What I do", value: "Build and ship full-stack products with strong engineering foundations" },
    { label: "Core Stack", value: "React/Next.js, TypeScript, Node/Fastify, Prisma/PostgreSQL" },
    { label: "Proof of delivery", value: "543+ personal commits across two core products (one live in production)" },
    { label: "Availability", value: "Internship, co-op, part-time, contract, and entry-level roles" },
    { label: "Work mode", value: "Remote, hybrid, or on-site (Canada)" }
  ],

  skills: [
    { group: "Languages", items: ["Java", "TypeScript & JavaScript", "Python", "C", "SQL", "Assembly"] },
    { group: "Frontend", items: ["React", "Next.js", "Vite", "Tailwind CSS", "Ant Design", "Responsive UI"] },
    { group: "Backend and Data", items: ["Node.js", "Fastify", "Prisma", "PostgreSQL", "REST APIs", "Redis"] },
    { group: "Tooling and Platform", items: ["Git/GitHub", "Vercel", "Docker basics", "OAuth", "S3-compatible storage", "CLI development"] }
  ],

  projects: [
    {
      name: "WuwaCalculator",
      period: "2025 - Present",
      type: "Production Web Application",
      status: "Live",
      summary:
        "A live Wuthering Waves damage calculator and optimizer built as a full React + TypeScript web app with detailed combat logic, build tools, rotation planning, and persistent user data.",
      highlights: [
        "Built a large feature-complete calculator covering damage calculation, build optimization, rotation workflows, team setup, weapon and Echo management, and character-specific logic.",
        "Designed modular override systems for resonators, weapons, gear, buffs, and skill behavior so game-specific mechanics can be added without breaking the wider app.",
        "Implemented persistent app state, migrations, inventory-style data management, and Google Drive sync workflows to preserve builds, rotations, and user configuration across sessions.",
        "Added practical product features including OCR-based Echo import, responsive routed UI, detailed stat views, changelog/help-style routes, and production deployment under a live domain."
      ],
      stack: [
        "React",
        "TypeScript",
        "Vite",
        "Zustand",
        "React Router",
        "Floating UI",
        "Tesseract.js",
        "Google OAuth",
        "Google Drive API"
      ],
      links: [
        { label: "Live App", url: "https://thewuwacalculator.com/" },
        { label: "Repository", url: "https://github.com/ssjrunor/thewuwacalculator" }
      ],
      evidence: [
        "Public live deployment at thewuwacalculator.com",
        "Large TypeScript/React codebase with modular game-logic architecture",
      ]
    },
    {
      name: "Karmitis Platform",
      period: "2026 - Present",
      type: "Full-Stack Platform",
      status: "In Active Development",
      summary:
        "A multi-repo platform (dashboard + accounts API + CLI) focused on clean auth, permissions, and developer-first workflows.",
      highlights: [
        "Built an accounts/auth service: sessions, trusted apps, permissions, account flows, and audit events.",
        "Developed a Next.js dashboard with global search, notifications, trust management, and session-expiration handling.",
        "Added production-minded integrations: Postgres migrations, optional Redis, S3-compatible storage, and SMTP support.",
        "Built a CLI for fast onboarding and ergonomic account workflows for developers."
      ],
      stack: ["Next.js", "React", "TypeScript", "Fastify", "Prisma", "PostgreSQL", "Redis", "S3 APIs"],
      links: [
        { label: "Platform Info", url: "https://karmitis.com" },
        { label: "CLI Repository", url: "https://github.com/ssjrunor/karmitis-cli" }
      ],
      evidence: [
        "Core app and API repositories are private",
        "CLI actively evolving with auth + UX improvements"
      ]
    }
  ],

  experience: [
    {
      role: "Independent Software Developer",
      org: "Personal and Community-Facing Projects",
      period: "2025 - Present",
      bullets: [
        "Build and ship products end-to-end: design, architecture, implementation, deployment, and iteration.",
        "Optimize for clarity and correctness while keeping UX smooth and fast.",
        "Maintain sustainable codebases with modular structure, conventions, and documentation."
      ]
    }
  ],

  education: {
    school: "University of New Brunswick – Saint John",
    degree: "Bachelor of Computer Science",
    timeline: "2023 - Present",
    notes:
      "Coursework plus long-running product work focused on software engineering fundamentals and real-world delivery.",
    coursework: [
      "Data Structures and Algorithms",
      "Computer Architecture and Low-Level Programming",
      "Software Design and Implementation",
      "Databases",
      "Operating Systems"
    ]
  },

  opportunities: {
    title: "What I Am Looking For",
    intro:
      "Software roles where I can own meaningful work, ship improvements quickly, and keep growing under high standards.",
    items: [
      "Internship / Co-op (Full-Stack, Backend, Frontend)",
      "Part-time roles during the school year",
      "Contract work with clear deliverables",
      "Entry-level full-time roles aligned with 2027 graduation"
    ]
  }
};

export default portfolioData;